function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable react/prop-types */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { AgGridDefault } from "./AgGridDefault";
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { GridPagination } from "../GridPagination";
import useGridPagination from "./useGridPagination";
export function AgGridPaginated(props) {
  var onGridReadyProp = props.onGridReady,
    pageSizeOptions = props.pageSizeOptions;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    gridApi = _useState2[0],
    setGridApi = _useState2[1];
  var _useGridPagination = useGridPagination(gridApi),
    pageSize = _useGridPagination.pageSize,
    rowCount = _useGridPagination.rowCount,
    currentPage = _useGridPagination.currentPage,
    lastPage = _useGridPagination.lastPage,
    setPageSize = _useGridPagination.paginationSetPageSize,
    goToPage = _useGridPagination.paginationGoToPage,
    updatePagination = _useGridPagination.updatePagination;
  var handleGridReady = useCallback(function (params) {
    setGridApi(params.api);
    if (onGridReadyProp) {
      onGridReadyProp(params);
    }
  }, [onGridReadyProp]);
  var onPaginationChanged = useCallback(
  // this is can take an object as an argument, with keys animate, keepRenderedRows, newData, newPage
  function () {
    updatePagination();
  }, [updatePagination]);

  // required pagination props added to overwrite potentially invalid pagination default props
  var gridProps = _objectSpread(_objectSpread({}, props), {}, {
    onGridReady: handleGridReady,
    onPaginationChanged: onPaginationChanged,
    pagination: true,
    paginationAutoPageSize: false,
    suppressPaginationPanel: true
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ag-theme-alpine",
    style: {
      height: '100%',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(AgGridDefault, gridProps)), gridApi && /*#__PURE__*/React.createElement(GridPagination, {
    pageSize: pageSize,
    rowCount: rowCount,
    currentPage: currentPage,
    lastPage: lastPage,
    setPageSize: setPageSize,
    goToPage: goToPage,
    pageSizeOptions: pageSizeOptions === undefined ? null : pageSizeOptions,
    hidePageNavigationGroup: props.hidePageNavigationGroup,
    hideSkipButtons: props.hideSkipButtons,
    hidePageSizeSelector: props.hidePageSizeSelector
  }));
}
AgGridPaginated.defaultProps = {
  rowData: [],
  pagination: true,
  paginationAutoPageSize: true,
  modules: AllModules,
  defaultColDef: {
    floatingFilter: true,
    suppressMenu: true,
    suppressFilterButton: true
  }
};
AgGridPaginated.propTypes = {
  // eslint-disable-next-line import/no-named-as-default-member
  rowData: PropTypes.arrayOf(PropTypes.object).isRequired
};